// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background: var(--surface-sunken);
  color: var(--text);
  font-family: 'DM Sans', sans-serif;
  min-height: 100vh;
}

/* The page scrollbar belongs to <body>, which sits outside the \`.lightPage\`
   and \`.lightRoot\` wrappers that carry the theme — so it cannot be scoped to
   one. Painting the track with a dark surface token left a dark strip down the
   edge of every light page. A transparent track and a translucent thumb read
   correctly on either, without needing to know which is on. */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: rgba(138, 127, 116, 0.45);
  border-radius: var(--radius-4);
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(138, 127, 116, 0.7);
}
::-webkit-scrollbar-corner {
  background: transparent;
}

/* Firefox has no track/thumb selectors, so it is told the same two colours. */
* {
  scrollbar-color: rgba(138, 127, 116, 0.45) transparent;
  scrollbar-width: thin;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;;;8DAI8D;AAC9D;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EACE,sDAAsD;EACtD,qBAAqB;AACvB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background: var(--surface-sunken);\n  color: var(--text);\n  font-family: 'DM Sans', sans-serif;\n  min-height: 100vh;\n}\n\n/* The page scrollbar belongs to <body>, which sits outside the `.lightPage`\n   and `.lightRoot` wrappers that carry the theme — so it cannot be scoped to\n   one. Painting the track with a dark surface token left a dark strip down the\n   edge of every light page. A transparent track and a translucent thumb read\n   correctly on either, without needing to know which is on. */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: rgba(138, 127, 116, 0.45);\n  border-radius: var(--radius-4);\n}\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(138, 127, 116, 0.7);\n}\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Firefox has no track/thumb selectors, so it is told the same two colours. */\n* {\n  scrollbar-color: rgba(138, 127, 116, 0.45) transparent;\n  scrollbar-width: thin;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
